import {fetch} from '@infra/api/fetch';

const URL = '/api/pleaseLogThis';

export const sendLogMessage = async (message: string): Promise<void> => {
  await fetch(URL, {method: 'POST', body: `[UAF] ${message}`});
};
